export type IRemoveArrayItemByName = (arr: any[], name: string) => any[];

export function removeArrayItemByName(arr: any[], name: string): any[] {
  const arrayLength = arr.length;
  let n;
  let i = 0;
  let index = -1;
  // Remove the original value
  for (i; i < arrayLength; i += 1) {
    n = arr[i].name;
    if (n === name) {
      index = i;
      break;
    }
  }
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}
